module.exports = __webpack_public_path__ + "img/Sei Ken Co,Ltd．.43611284.png";